import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "./logolist.scss";

export default function LogoList({ speed = 3000, circle = false }) {
  const logos = [
  "/images/1.png",
  "/images/2.png",
  "/images/3.png",
  "/images/4.png",
  "/images/5.png",
  "/images/6.png",
  "/images/7.png",
  "/images/8.png",
  "/images/9.png",
  "/images/10.png",
  "/images/11.png",
  "/images/12.png",
  "/images/13.png",
  "/images/14.png",
  "/images/15.png",
  "/images/16.png",
  "/images/17.png",
  "/images/18.png",
  "/images/19.png",
  ];

  const loopItems = [...logos, ...logos]; // infinite loop

  return (
    <div className="logo-marquee">
      {/* Row 1 — Left Direction */}
        <Swiper
          modules={[Autoplay]}
          loop={true}
          allowTouchMove={false}
          speed={speed}
          autoplay={{
            delay: 0,
            reverseDirection: false,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: { slidesPerView: 3 },      // ⭐ Mobile
            576: { slidesPerView: 4 },    // Small devices
            992: { slidesPerView: 5 },    // Desktop
          }}
        >

        {loopItems.map((src, i) => (
          <SwiperSlide key={i}>
            <div className={`logo-box ${circle ? "circle" : ""}`}>
              <img src={src} alt="brand" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
